// extracted by mini-css-extract-plugin
export default {"disclosure":"styles_disclosure__y3mOX","icon":"styles_icon__EShX6","unorderedList":"styles_unorderedList__rwEJ+"};